import { useEffect, useState } from 'react';

const QUERY = '(max-width: 639px)';

// true em telas estreitas (< 640 px): as telas do historico trocam tabelas por cartoes
export const useNarrow = () => {
  const [narrow, setNarrow] = useState(() => typeof window !== 'undefined' && window.matchMedia(QUERY).matches);
  useEffect(() => {
    const mq = window.matchMedia(QUERY);
    const on = () => setNarrow(mq.matches);
    mq.addEventListener('change', on);
    return () => mq.removeEventListener('change', on);
  }, []);
  return narrow;
};

const Meta = ({ items }) => {
  const shown = items.filter(it => it && it[1] !== undefined && it[1] !== null && it[1] !== '');
  if (!shown.length) return null;
  return (
    <div className="mt-1 text-[11px] text-[#71717A] flex flex-wrap gap-x-3 gap-y-0.5">
      {shown.map(([label, value], i) => (
        <span key={i} className="break-words min-w-0">{label && <span className="text-[#A1A1AA]">{label} </span>}{value}</span>
      ))}
    </div>
  );
};

// Cartao compacto: titulo a esquerda, valor sempre inteiro a direita, campos secundarios abaixo
export const MobileRow = ({ title, value, meta = [], onClick, active, testId, children, className = '' }) => (
  <div onClick={onClick} data-testid={testId}
    className={`bg-white rounded-xl border px-3 py-2.5 ${active ? 'border-[#1B4332] bg-[#ECFDF5]' : 'border-[#E4E4E7]'} ${onClick ? 'cursor-pointer active:bg-[#F7F6F4]' : ''} ${className}`}>
    <div className="flex items-start gap-3">
      <div className={`min-w-0 flex-1 text-sm break-words ${active ? 'font-semibold text-[#1B4332]' : 'font-medium text-[#18181B]'}`}>{title}</div>
      {value !== undefined && <div className="shrink-0 text-right text-sm font-semibold text-[#18181B] whitespace-nowrap">{value}</div>}
    </div>
    <Meta items={meta} />
    {children}
  </div>
);

export const MobileRows = ({ rows, empty, testPrefix }) => (
  <div className="space-y-2" data-testid={testPrefix ? `${testPrefix}-mobile` : undefined}>
    {rows.length === 0 && <div className="bg-white rounded-xl border border-[#E4E4E7] px-4 py-6 text-center text-xs text-[#A1A1AA]">{empty}</div>}
    {rows.map((r, i) => <MobileRow key={r.key ?? i} testId={testPrefix ? `${testPrefix}-${i}` : undefined} {...r} />)}
  </div>
);

// Linha "rotulo ........ valor" para blocos de resumo no celular
export const KV = ({ label, value, strong, testId }) => (
  <div className={`flex items-baseline gap-3 py-1 text-xs ${strong ? 'font-semibold text-[#18181B]' : 'text-[#52525B]'}`} data-testid={testId}>
    <span className="min-w-0 flex-1 break-words">{label}</span>
    <span className="shrink-0 whitespace-nowrap text-right">{value}</span>
  </div>
);
